import { Observable } from '@apollo/client/utilities'
import { CombinedGraphQLErrors } from '@apollo/client'
import { ErrorLink } from '@apollo/client/link/error'

import { setUnauthorizedNotification } from '../../components/notification'
import { renewTokens } from '../../http-client'
import { setGenericErrorNotification } from '../../components/notification/genericResponseErrorNotification'

export const createErrorLink = () =>
  new ErrorLink(({ error, operation, forward }) => {
    if (CombinedGraphQLErrors.is(error)) {
      const isUnauthenticated = error.errors.some(e => e.extensions?.code === 'UNAUTHENTICATED')

      if (isUnauthenticated) {
        return new Observable(observer => {
          renewTokens()
            .then(renewResponse => {
              if (!renewResponse) {
                setUnauthorizedNotification()
                observer.error(new Error('Token renewal returned no response'))
                return
              }

              const oldHeaders = operation.getContext().headers
              operation.setContext({
                headers: {
                  ...oldHeaders,
                  Authorization: `Bearer ${renewResponse.data.accessToken}`,
                },
              })

              forward(operation).subscribe({
                next: (result) => observer.next(result),
                error: (err) => observer.error(err),
                complete: () => observer.complete(),
              })
            })
            .catch(() => {
              setUnauthorizedNotification()
              observer.error(new Error('Token renewal failed'))
            })
        })
      }

      const messages = error.errors
        .filter(e => e.extensions?.code !== 'UNAUTHENTICATED')
        .map(e => {
          console.error(`[GraphQL error]: ${JSON.stringify(e)}`)
          return e.message
        })

      if (messages.length > 0) {
        setGenericErrorNotification('Virhe kyselyssä', messages.join(', '))
      }

      return forward(operation)
    } else {
      const errorMessage = error instanceof Error ? error.message : String(error)
      console.error(`[Network error]: ${errorMessage}`)
      setGenericErrorNotification('Verkkovirhe', errorMessage)

      return forward(operation)
    }
  })
